import type { ProductUpsellsConfig } from '#types/config/components/product/upsells'

export default {
  brandClasses: {
    title: 'subtitle-4'
  }
} satisfies ProductUpsellsConfig
